import React, { useMemo, useCallback } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	onChange: (value: string) => void;
	setId: string;
}

export const RecipientBic: React.FC<IProps> = React.memo(({ onChange, setId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterRecipientBic') },
			{
				validator(_, value) {
					if (!value || value.length === 9) {
						return Promise.resolve();
					}
					return Promise.reject(new Error(t('enterRecipientBicShouldContainCertainNumberOfDigits')));
				},
			},
		],
		[t],
	);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '').slice(0, 9);
			onChange(onlyDigits);
			return onlyDigits;
		},
		[onChange],
	);

	return (
		<FormInput
			testId="RecipientBic"
			name={`recipientBic-${setId}`}
			label="recipientBicLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
});
